<template>


  <div class="container border shadow-sm m-3 p-2 py-4 card-store-201">
    <div class="row align-items-center">
      <div class="col-lg-3 text-center">


        <img class="img-fluid shadow " :src="authorLogo" :alt="findAttributeOnSiteInfo('site_name')">

      </div>
      <div class="col-lg-6 py-3 text-center">
        <h5 class="pt-3 font-weight-bold mb-3">{{ authorName }}</h5>
        <span class="pt-3"> {{ storeDescription()["استان"] }}</span>
        <span class="px-2 text-secondary">|</span>
        <span class="pt-3"> {{ storeDescription()["شهر"] }}</span>

      </div>
      <div class="col-lg-3 py-3 text-center">
        <m-a :href="{name:'SingleStore',params:{store:  storeName }}">
          <div class="btn btn-primary p-3 rounded rounded-pill shadow">
            مشاهده فروشگاه
          </div>
        </m-a>
      </div>
    </div>
  </div>

</template>


<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import MA from "../../../Tags/A.vue";

export default {
  name: "StoreDescription1",
  components: {MA},
  props: {
    product: {},
    stateView: {
      default: false,
      type: Boolean,
    },
    productAuthor: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    storeName() {
      if (this.productAuthor && Object.keys(this.product).length > 0) {
        return this.product.user != null ? this.product.user.name : '1'
      }
      return '1'
    },
    authorName() {
      if (this.productAuthor && Object.keys(this.product).length > 0) {
        return this.product.user != null ? this.product.user.name : findAttributeOnSiteInfo('site_name')
      }
      return findAttributeOnSiteInfo('site_name')[0]
    },
    authorDescription() {
      if (this.productAuthor && Object.keys(this.product).length > 0) {
        let userDescription = this.product.user
        return userDescription != null ? userDescription.description : findAttributeOnSiteInfo('site_name')[0]
      }
      return findAttributeOnSiteInfo('site_name')[0]
    },
    authorLogo() {
      if (this.productAuthor && Object.keys(this.product).length > 0) {
        let productUser = this.product.user
        return productUser != null ? productUser.image : userAvatar
      }
      return userAvatar
    },

  },
  methods: {
    storeDescription() {
      try {
        // اگر store.description وجود داشته باشد، آن را پارس می‌کنیم
        if (this.authorDescription != null) {
          return JSON.parse(this.authorDescription);
        }
        return {}; // اگر store.description تهی بود یا null باشد، یک شی خالی برمی‌گردانیم
      } catch (error) {
        // در صورتی که خطا در پردازش JSON رخ دهد
        console.error('Error parsing store description:', error);
        return {}; // در صورت بروز خطا، یک شی خالی برمی‌گردانیم
      }
    }
  }

}

</script>

<style scoped>
.col-lg-3 img {
  aspect-ratio: 1 / 1;
  height: 150px;
  border-radius: 50%;
  border: 3px solid var(--primary);
  padding: 3px;
}

.card-store-201 {
  border-radius: 15px;
  background: #fefefe;
}

</style>